import { Link } from "react-router-dom";
import { ArrowRight, Globe, Server, Monitor, ShoppingCart, Search, Target, Wrench, CalendarClock, Mail, Building2, type LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import servicesWebImage from "@/assets/services-web.jpg";
import servicesSeoImage from "@/assets/services-seo.jpg";

interface Service {
  title: string;
  description: string;
  href: string;
  icon: LucideIcon;
}

const services: Service[] = [
{
  title: "Website per maand",
  description: "Een professionele website zonder hoge opstartkosten. Vast bedrag per maand.",
  href: "/diensten/website-per-maand",
  icon: CalendarClock
},
{
  title: "Website bouwen",
  description: "Een professionele website die doet wat 'ie moet doen. Snel, overzichtelijk en gericht op resultaat.",
  href: "/diensten/websites-bouwen",
  icon: Monitor
},
{
  title: "Webshop bouwen",
  description: "Online verkopen zonder gedoe. Een webshop die werkt en groeit met je bedrijf.",
  href: "/diensten/webshops-bouwen",
  icon: ShoppingCart
},
{
  title: "SEO",
  description: "Gevonden worden in Google. Structureel werken aan je vindbaarheid.",
  href: "/diensten/seo",
  icon: Search
},
{
  title: "SEA",
  description: "Direct zichtbaar met Google Ads. Beheer en optimalisatie van je campagnes.",
  href: "/diensten/sea",
  icon: Target
},
{
  title: "Domeinnamen",
  description: "Je eigen domeinnaam. Het online adres van je bedrijf.",
  href: "/diensten/domeinnamen",
  icon: Globe
},
{
  title: "Hosting",
  description: "Betrouwbare hosting. Je website altijd online en snel.",
  href: "/diensten/hosting",
  icon: Server
},
{
  title: "Zakelijke E-mail",
  description: "Professioneel mailen op je eigen domeinnaam. Betrouwbaar en veilig.",
  href: "/diensten/zakelijke-email",
  icon: Mail
},
{
  title: "Google Workspace",
  description: "Gmail, Agenda, Drive en meer op je eigen domein. Alles wat je nodig hebt.",
  href: "/diensten/google-workspace",
  icon: Building2
}];


export function ServicesPreview() {
  return (
    <section className="section-padding bg-muted">
      <div className="container-wide">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start mb-16">
          <div>
            <p className="text-small uppercase tracking-widest mb-4">Diensten</p>
            <h2>Wat ik voor je regel</h2>
            <p className="mt-4 text-muted-foreground">
              Alles wat je nodig hebt voor een sterke online aanwezigheid. Onder één dak.
            </p>
          </div>
          
          {/* Featured images */}
          <div className="hidden lg:grid grid-cols-2 gap-4">
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src={servicesWebImage}
                alt="Website analytics dashboard"
                className="w-full h-full object-cover"
                width={264}
                height={198}
                sizes="264px"
                loading="lazy"
                decoding="async" />
              
            </div>
            <div className="aspect-[4/3] rounded-lg overflow-hidden mt-8">
              <img

                alt="Werken aan SEO optimalisatie"
                className="w-full h-full object-cover"
                width={264}
                height={198}
                sizes="264px"
                loading="lazy"
                decoding="async" src="/lovable-uploads/fd51e011-7abd-4cdc-94ed-69210f93ac17.png" />
              
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-border rounded-xl overflow-hidden shadow-lg">
          {services.map((service, index) =>
          <Link
            key={service.href}
            to={service.href}
            className="group bg-background p-8 md:p-10 hover:bg-primary hover:text-white transition-all duration-300">
            
              <div className={`w-12 h-12 rounded-lg mb-5 flex items-center justify-center bg-primary/10 group-hover:bg-white/20 transition-colors`}>
                <service.icon className="w-6 h-6 text-primary group-hover:text-white transition-colors" />
              </div>
              <h3 className="mb-3 group-hover:text-white transition-colors">{service.title}</h3>
              <p className="text-muted-foreground text-sm mb-6 group-hover:text-white/80 transition-colors">{service.description}</p>
              <span className="inline-flex items-center text-sm font-medium text-foreground group-hover:text-white transition-colors">
                Bekijk dienst
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          )}
        </div>

        <div className="mt-12 mb-12 pb-12 border-b border-border">
          <Button asChild variant="outline" size="lg">
            <Link to="/diensten">
              Alle diensten bekijken
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>);

}